import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { getCategoryEditModel } from './categoryEditFormModel';
import { usePost } from 'components';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { SiteLink } from 'components';

export function CategoryNew(props) {
  const model = getCategoryEditModel({});
  console.log(model)

  return <CategoryEditForm model={model} />
}

function CategoryEditForm({ model }) {
  const form = useForm(model, {});
  const post = usePost();
  const { Redirect } = useRouter();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      post.send(env.apiBase + "/api/categoryAdmin/createCategory", value);
    })
  }

  if (post.done()) {
    //const categoryId = post.response.results.categoryId;
    //return <Redirect to={`/admin/category/${categoryId}`} />
    return <Redirect to={`/admin/categories`} />
  }

  return (
    <div className="editor categoryEditor">
      <h1>New Category</h1>

      <section>
        <div className="row">
          <div className="col-md-9">{render('categoryName')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Create</Button>
            <SiteLink className="btn btn-outline-dark" to="/admin/categories">Cancel</SiteLink>
          </div>
        </div>
      </section>
    </div>
  );
}